import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function MensCricketIndividual() {
  const [userId, setUserId] = useState("");
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [age, setAge] = useState("");
  const [height, setHeight] = useState("");       // in cm
  const [weight, setWeight] = useState("");
  const [position, setPosition] = useState("");
  const [arm, setArm] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState({
    street: "",
    city: "",
    state: "",
    postalCode: "",
  });
  const [image, setImage] = useState(null);
  const fileInputRef = useRef(null);

  const positions = [
    "Batsman",
    "Spin Bowler",
    "Fast Bowler",
    "Medium Bowler",   // ✅ Added
    "All-Rounder",
    "Wicket Keeper",
    "Captain",
    "Vice-Captain",
  ];

  const arms = ["Right-Handed", "Left-Handed", "Ambidextrous"];

  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");
    if (storedUserId) setUserId(storedUserId);
  }, []);

  const handleRegister = async () => {
    // ✅ Validate all fields
    if (
      !firstName ||
      !lastName ||
      !age ||
      !height ||
      !weight ||
      !position ||
      !arm ||
      !email ||
      !phone ||
      !address.street ||
      !address.city ||
      !address.state ||
      !address.postalCode ||
      !image
    ) {
      return Swal.fire({
        icon: "warning",
        title: "⚠️ Missing Fields",
        text: "Please fill in all fields before submitting.",
        timer: 3000,
        showConfirmButton: false,
      });
    }

    const formData = {
      // userId can be empty; backend will generate it
      firstName,
      lastName,
      age,
      height,
      weight,
      position,
      arm,
      email,
      phone,
      address,
      photo: image,
    };

    try {
      // Show loading spinner
      Swal.fire({
        title: '⏳ Submitting your registration...',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const res = await fetch("https://node.aattumtpl.com/api/men-individual/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      Swal.close(); // close spinner

      if (res.ok && data.success) {
        Swal.fire({
          icon: "success",
          title: "🎉 Registered Successfully!",
          html: `<p>Your Player ID: <b>${data.userId}</b></p>
               <p>Redirecting to homepage...</p>`,
          timer: 4000,
          showConfirmButton: true,
        });

        localStorage.removeItem("userId");
        navigate("/", { replace: true });
        window.scrollTo(0, 0);
      } else {
        Swal.fire({
          icon: "error",
          title: "❌ Registration Failed",
          text: data.message || "Unknown error occurred.",
        });
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "🚨 Server Error",
        text: "Could not connect to server. Please try again later.",
      });
    }
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file)); // ✅ preview only (not base64)
      e.target.value = null;
    }
  };

  const handleImageClick = () => {
    fileInputRef.current.click();
  };


  return (
    <div className="sheet">
      {/* Banner */}

      <div className="banner">
        <img
          src="https://www.bobcard.co.in/_next/image?url=https%3A%2F%2Fmedia.bobcard.co.in%2Fmedia%2Fgw4ic3ru%2Fipl-top-banner-image_-1200px-470px.jpg&w=3840&q=75"
          alt="Cricket ground"
        />
        <div className="batsman-overlay" aria-hidden />
      </div>


      {/* Form Header */}
      <div className="content">
        <h1 className="title">ATPL MEN’S T-20 CHAMPIONSHIP</h1>
        <p className="subtitle">
          Individual Registration Form - {userId && `(${userId.toUpperCase()})`}
        </p>


        {/* Personal Info */}
        <div className="row">
          <div className="field two-col">
            <label>Full Name</label>
            <div className="grid-2">
              <input
                type="text"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <input
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>
          <div className="field">
            <label>Age</label>
            <input
              type="number"
              min={8}
              max={70}
              value={age}
              onChange={(e) => setAge(e.target.value)}
            />
          </div>
        </div>


        {/* Cricket Info */}
        <div className="row">
          <div className="field">
            <label>Playing Position</label>
            <select
              value={position}
              onChange={(e) => setPosition(e.target.value)}
            >
              <option value=""></option>
              {positions.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>

          <div className="field">
            <label>Batting/Bowling Arm</label>
            <select value={arm} onChange={(e) => setArm(e.target.value)}>
              <option value=""></option>
              {arms.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="row">
          <div className="field">
            <label>Height (cm)</label>
            <input
              type="number"

              value={height}
              onChange={(e) => setHeight(e.target.value)}
              min="100"
              max="250"
            />
          </div>

          <div className="field">
            <label>Weight (kg)</label>
            <input
              type="number"

              value={weight}
              onChange={(e) => setWeight(e.target.value)}
              min="30"
              max="200"
            />
          </div>
        </div>
        {/* Contact Info */}
        <div className="row">
          <div className="field">
            <label>Email</label>
            <input
              type="email"
              placeholder="example@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="field">
            <label>Phone Number</label>
            <input
              type="tel"
              placeholder="+91 00000 00000"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
        </div>

        {/* Address */}
        <div className="field">
          <label>Address</label>
        </div>

        <div className="field">
          <input
            type="text"
            placeholder="Street Address"
            value={address.street}
            onChange={(e) => setAddress({ ...address, street: e.target.value })}
          />
        </div>

        <div className="row">
          <div className="field">
            <input
              type="text"
              placeholder="City"
              value={address.city}
              onChange={(e) => setAddress({ ...address, city: e.target.value })}
            />
          </div>
          <div className="field">
            <input
              type="text"
              placeholder="District / Province"
              value={address.state}
              onChange={(e) => setAddress({ ...address, state: e.target.value })}
            />
          </div>
        </div>

        <div className="field">
          <input
            type="text"
            placeholder="Postal / Zip Code"
            value={address.postalCode}
            onChange={(e) => setAddress({ ...address, postalCode: e.target.value })}
          />
        </div>

        {/* Upload Photo */}
        <div className="field">
          <label>Upload Photo</label>
          <div className="drop">
            <input
              type="file"
              accept="image/*"
              className="file-input"
              onChange={handleFileChange}
              ref={fileInputRef}
            />
            {image ? (
              <img
                src={image}
                alt="Preview"
                className="preview-image"
                onClick={handleImageClick}
                style={{ cursor: "pointer" }}
              />
            ) : (
              <div
                className="drop-inner"
                onClick={() => fileInputRef.current.click()}
              >
                <div className="cloud" aria-hidden />
                <strong>Browse Files</strong>
                <span>Drag and drop files here</span>
              </div>
            )}
          </div>
        </div>

        {/* Submit */}
        <div className="actions">
          <button type="button" className="btn" onClick={handleRegister}>
            Register
          </button>
        </div>

      </div>

      {/* Styles */}
      <style>{`
        :root {
          --theme: #f3f3f3ff;
          --ink: #264653;
          --line: #d1e0ea;
          --accent: #0d47a1;
        }
        * { box-sizing: border-box; }
        body { margin: 0; background: var(--theme); font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial; color: var(--ink); margin-top: 100px; }
        .sheet { width: 210mm; min-height: 297mm; background: #fff; border-radius: 5px; overflow: hidden; margin: 20px auto; margin-top: 20px; }
        .content { padding: 18mm 16mm 20mm; }
        .banner { position: relative; height: 62mm; overflow: hidden; }
        .banner img { width: 100%; height: 100%; object-fit: cover; display:block; }
        .batsman-overlay { position: absolute; right: 16mm; bottom: -6mm; width: 95mm; height: 95mm;  pointer-events: none; }
        .title { margin: -30px 0 2mm; text-align: center; letter-spacing: .06em; color: #31647b; font-weight: 700; font-size: 8mm; }
        .subtitle { margin: 0 0 8mm; text-align: center; color: #64748b; font-size: 4mm; }
        .row { display: grid; grid-template-columns: 1fr 1fr; gap: 6mm; }
        .field { display: flex; flex-direction: column; gap: 1.5mm; margin-bottom: 4mm; }
        .grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 2mm; }
        input, select { height: 11mm; border: 1px solid #c3d4e6; border-radius: 1.5mm; padding: 0 4mm; font-size: 3.8mm; outline: none; }
        input:focus, select:focus { border-color: #7aa7c7; box-shadow: 0 0 0 2px rgba(56, 189, 248, .15); }
        .drop { position: relative; border: 1.5px dashed #cbd5e1; border-radius: 1.5mm; width: 100%; max-width: 173mm; height: 50mm; display: grid; place-items: center; overflow: hidden; }
        .file-input { position: absolute; inset: 0; opacity: 0; cursor: pointer; }
        .drop-inner { text-align: center; display: grid; gap: 1mm; }
        .cloud { width: 40px; height: 40px; margin: 0 auto 8px auto; background: url("data:image/svg+xml;utf8,<svg fill='%23cc3366' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M19.35 10.04c-.68-3.59-4.08-6.04-7.76-5.26-2.41.48-4.31 2.39-4.79 4.8C4.57 10.16 3 12.03 3 14.25 3 16.73 5.02 18.75 7.5 18.75h11c2.21 0 4-1.79 4-4 0-1.93-1.37-3.57-3.15-3.96zM12 12v4m0-4l-2 2m2-2l2 2' stroke='%23888' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>") no-repeat center; background-size: contain; }
        .preview-image { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: contain; border-radius: 1.5mm; background: #f0f0f0; }
        .actions { display: flex; justify-content: center; margin-top: 6mm; }
        .btn { background: #007BFF; color: #fff; border: none; border-radius: 1.5mm; height: 12mm; font-size: 13px; cursor: pointer; width: 120px; }
        .btn:hover { filter: brightness(1.05); }
       /* ---------- MOBILE VIEW OPTIMIZATION ---------- */
@media screen and (max-width: 600px) {
  .page-wrap {
    padding: 12px;
  }

  .sheet {
    width: 100%;
    min-height: auto;
    border-radius: 0;
    box-shadow: none;
  }

  .content {
    padding: 16px 12px 20px;
  }

  /* ✅ Stack labels above dropdowns */
  .row {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .field {
    width: 100%;
    margin-bottom: 12px;
  }

  .field label {
    font-size: 14px;
    margin-bottom: 6px;
    color: #333;
  }

  input[type="text"],
  input[type="email"],
  input[type="number"],
  input[type="tel"],
  select {
    width: 100%;
    height: 44px;
    font-size: 15px;
    padding: 10px 12px;
    border-radius: 6px;
  }

  /* ✅ Upload section adjustment */
  .drop {
    height: 160px;
    max-width: 100%;
  }

  .drop-inner span {
    font-size: 13px;
  }

  /* ✅ Button full width */
 .actions {
  display: flex;
  justify-content: center;  /* ✅ Centers horizontally */
  align-items: center;       /* ✅ Centers vertically if needed */
  flex-direction: column;    /* ✅ Stacks if more than one button */
  gap: 10px;
  margin-top: 20px;
}

.btn {
  width: 100%;
  max-width: 150px;   /* ✅ Button won’t stretch beyond 150px */
  height: 46px;
  font-size: 15px;
  text-align: center; /* ✅ Text centered inside button */
}


  /* ✅ Title and subtitle size adjustment */
  .title {
    font-size: 22px;
    margin-top: -10px;
  }

  .subtitle {
    font-size: 14px;
    margin-bottom: 16px;
  }

  /* ✅ Banner smaller height for phones */
  .banner {
    height: 160px;
  }

  .batsman-overlay {
    display: none;
  }
}

      `}</style>
    </div>
  );
};


